import {FileInput, FileInputProps} from '@mantine/core'
import {useThemeMode} from '../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'

const CustomFileInput = (props: FileInputProps) => {
  const {mode} = useThemeMode()
  return (
    <>
      <style>
        {`.mantine-FileInput-error{font-size:1rem;}  
.mantine-FileInput-input:focus{outline: none;
border-color: #228be6;}
${
  mode == 'dark' &&
  `.mantine-FileInput-input:disabled, .mantine-FileInput-input[data-disabled] {
  background-color: #474761;
  color: rgb(144, 146, 150);
  opacity: 0.6;
}`
}
.mantine-FileInput-input{
  outline: none;
  border-color: var(--bs-gray-300);}
`}
      </style>
      <FileInput {...props} withAsterisk={props.withAsterisk ?? true} size={props.size ?? 'md'} />
    </>
  )
}

export default CustomFileInput
